import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";

const { REACT_APP_API_HOST, REACT_APP_WP_HOST } = process.env;

const socket = io(REACT_APP_API_HOST); // eslint-disable-line
const client = feathers(); // eslint-disable-line
client.configure(feathers.socketio(socket)); // eslint-disable-line
const waitTimeService = client.service("/api/v1/wait-time");

function VideoVisit() {
  const [waitTime, setWaitTime] = useState(null);
  const [availableHours, setAvailableHours] = useState("");

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(
          `${REACT_APP_WP_HOST}/wp-json/acf/v3/pages`
        );
        const json = await response.json();
        const videoPage = json.find(p => p.acf.available_hours);
        if (videoPage) {
          setAvailableHours(videoPage.acf.available_hours);
        }
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();

    const updateStatus = waitTimeToSet => {
      setWaitTime(waitTimeToSet);
    };

    waitTimeService.on("status", updateStatus);
    waitTimeService.find().then(updateStatus);

    return () => {
      waitTimeService.off("status", updateStatus);
    };
  }, []);

  if (!waitTime) return null;
  let buttonText = "Meet Now";
  let waitText = "We are online now!";
  if (!waitTime.offline) {
    if (waitTime.waitTime.min || waitTime.extraWait) {
      buttonText = "I'll Wait In Line";
      waitText = `Wait time is ${waitTime.waitTime.min + waitTime.extraWait}${
        waitTime.waitTime.max
          ? `-${waitTime.waitTime.max + waitTime.extraWait} min`
          : " min"
      }`;
    }
  }

  return (
    <div className="filterNurseDoctor_wrapper">
      <h1 className="title-header">Video Visit</h1>
      <h3 className="video-visit-center">
        On-demand. Click “Meet Now” below to chat with us now.
      </h3>
      <h4 className="video-visit-center">
        Please use Chrome, FireFox, Brave or Safari
      </h4>
      {waitTime.offline && availableHours ? (
        <React.Fragment>
          <h3 className="video-visit-center">Our office hours:</h3>
          <h3
            className="video-visit-center office-hours"
            dangerouslySetInnerHTML={{ __html: availableHours }}
          />
        </React.Fragment>
      ) : null}
      <div className="filterNurseDoctor_wrapper _colorMaroon">
        <Button
          onClick={() => {
            window.ga(
              "send",
              "event",
              "Click",
              "/about-video-visit/",
              "Video Visit Learn More from Scheduler",
              "0"
            );
            setTimeout(() => {
              window.location.href = "/about-video-visit/";
            }, 300);
          }}
          className="filterNurseDoctor"
        >
          Learn More{" "}
        </Button>
      </div>
      {waitTime.offline ? null : (
        <React.Fragment>
          <div className="filterNurseDoctor_wrapper no-margin-bottom _colorGreen">
            <Button
              onClick={() => {
                window.ga(
                  "send",
                  "event",
                  "Click",
                  "/video-visit/",
                  "Video Visit Meet Now from Scheduler",
                  "0"
                );
                setTimeout(() => {
                  window.location.href = "/video-visit/";
                }, 300);
              }}
              className="filterNurseDoctor"
            >
              {buttonText}
            </Button>
          </div>
          <h3 className="video-visit-online-now">{waitText}</h3>
        </React.Fragment>
      )}
    </div>
  );
}

export default VideoVisit;
